import React from 'react'
import { PushOrdersBar, PushOrdersTitle, PushOrdersDescription } from './styles'
import { PUSH_ORDERS_TITLE, PUSH_ORDERS_DESCRIPTION } from './copy'

// Renders no control of its own — each row's switch in the table below is the
// only way to change push-to-Leat.
const PushOrdersCard = () => (
  <PushOrdersBar>
    <div>
      <PushOrdersTitle>{PUSH_ORDERS_TITLE}</PushOrdersTitle>
      <PushOrdersDescription>{PUSH_ORDERS_DESCRIPTION}</PushOrdersDescription>
    </div>
  </PushOrdersBar>
)

export default PushOrdersCard
